import React, {useState} from "react";
import {NavLink} from "react-router-dom";

export default function (props: any) {
    return (
        <div id="kt_aside" className="aside bg-info">

            <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">

                <div className="aside-logo d-flex flex-column align-items-center flex-column-auto py-4 pt-lg-10 pb-lg-7"
                     id="kt_aside_logo">
                    <a href="#">
                        <img alt="Logo"
                             src="https://preview.keenthemes.com/start-html-pro/assets/media/logos/logo-compact.svg"
                             className="mh-50px"/>
                    </a>
                </div>


                <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid pt-0 pb-5"
                     id="kt_aside_nav">

                    <div className="hover-scroll-y">

                        <ul className="nav flex-column">

                            {/*<li className="nav-item mb-1">*/}
                            {/*    <NavLink to="/users"*/}
                            {/*             className={"nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"}>*/}

                            {/*        <span className="svg-icon svg-icon-2 svg-icon-lg-1"><svg*/}
                            {/*            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"*/}
                            {/*            fill="none">*/}
                            {/*            <path*/}
                            {/*                d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z"*/}
                            {/*                fill="black"/>*/}
                            {/*            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="black"/>*/}
                            {/*            </svg>*/}
                            {/*        </span>*/}
                            {/*        <span>Người dùng</span>*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}

                            <li className="nav-item mb-1">
                                <NavLink to="/accounts"
                                         className={"nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"}>

                                    <span className="svg-icon svg-icon-2 svg-icon-lg-1">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none">
													<path opacity="0.3"
                                                          d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                                          fill="black"></path>
													<path
                                                        d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                                        fill="black"></path>
												</svg>
											</span>
                                    <span>Tài khoản</span>
                                </NavLink>
                            </li>


                            <li className="nav-item mb-1">
                                <NavLink to="/orders"
                                         className={"nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"}>

                                    <span className="svg-icon svg-icon-2 svg-icon-lg-1">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none">
													<path opacity="0.3"
                                                          d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                                          fill="black"></path>
													<path
                                                        d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                                        fill="black"></path>
												</svg>
											</span>
                                    <span>Đơn hàng</span>
                                </NavLink>
                            </li>

                            {/*<li className="nav-item mb-1">*/}
                            {/*    <NavLink to="/tracking"*/}
                            {/*             className={"nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"}>*/}

                            {/*        <span className="svg-icon svg-icon-muted svg-icon-2hx"><svg*/}
                            {/*            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"*/}
                            {/*            fill="none">*/}
                            {/*            <path opacity="0.3"*/}
                            {/*                  d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"*/}
                            {/*                  fill="currentColor"/>*/}
                            {/*            <path*/}
                            {/*                d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"*/}
                            {/*                fill="currentColor"/>*/}
                            {/*            </svg></span>*/}
                            {/*        <span>Tracking</span>*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}

                            <li className="nav-item mb-1">
                                <NavLink to="/message"
                                         className={"nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white"}>

                                    <span className="svg-icon svg-icon-muted svg-icon-2hx"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path opacity="0.3"
                                              d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z"
                                              fill="currentColor"/>
                                        <rect x="6" y="12" width="7" height="2" rx="1" fill="currentColor"/>
                                        <rect x="6" y="7" width="12" height="2" rx="1" fill="currentColor"/>
                                        </svg></span>
                                    <span>Tin nhắn</span>
                                </NavLink>
                            </li>

                        </ul>

                    </div>

                </div>


                <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-5 py-lg-7"
                     id="kt_aside_footer">

                    <div className="mb-2" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-trigger="hover"
                         title="" data-bs-original-title="Quick settings">

                    </div>

                </div>

            </div>
        </div>
    )
}
